import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ITable } from '../../../interfaces/table';

type NewWidgetCodeForm = {
  widgetCode: FormControl<string>;
  dwallDeviceId: FormControl<string>;
};

@Component({
  selector: 'app-add-new-widget-code',
  templateUrl: './add-new-widget-code.component.html',
  styleUrls: ['./add-new-widget-code.component.scss']
})
export class AddNewWidgetCodeComponent implements OnInit {
  public newWidgetCodeForm: FormGroup<NewWidgetCodeForm> = this.generateForm();
  public table!: ITable;
  public connectionType: 'widgetCode' | 'dwallDeviceId' = 'widgetCode';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { table: ITable },
    public dialogRef: MatDialogRef<any>,
  ) { }

  ngOnInit(): void {
    this.table = this.data.table;
    this.updateConnectionValidators();
  }

  private generateForm(): FormGroup<NewWidgetCodeForm> {
    return new FormGroup({
      widgetCode: new FormControl('', { nonNullable: true }),
      dwallDeviceId: new FormControl('', { nonNullable: true, validators: [Validators.pattern(/^\d{12}$/)] }),
    });
  }

  public onConnectionTypeChange(index: number): void {
    this.connectionType = index === 0 ? 'widgetCode' : 'dwallDeviceId';
    this.updateConnectionValidators();
  }

  private updateConnectionValidators(): void {
    const { widgetCode: widgetCodeControl, dwallDeviceId: dwallDeviceIdControl } = this.newWidgetCodeForm.controls;

    if (this.connectionType === 'widgetCode') {
      widgetCodeControl?.setValidators([Validators.required]);
      dwallDeviceIdControl?.clearValidators();
    } else {
      widgetCodeControl?.clearValidators();
      dwallDeviceIdControl?.setValidators([Validators.required, Validators.pattern(/^\d{12}$/)]);
    }

    widgetCodeControl?.updateValueAndValidity();
    dwallDeviceIdControl?.updateValueAndValidity();
  }

  private getConnectionPayload(): { widgetCode?: string, dwallDeviceId?: string } {
    if (this.connectionType === 'widgetCode') {
      return { widgetCode: this.newWidgetCodeForm.controls.widgetCode.value.trim() };
    }

    return { dwallDeviceId: this.newWidgetCodeForm.controls.dwallDeviceId.value.trim() };
  }

  linkNewDevice(): void {
    const data = {
      tableId: this.table.id,
      restaurantId: this.table.restaurantId,
      ...this.getConnectionPayload(),
    };
    this.dialogRef.close(data);
  }
}
